// extracted by mini-css-extract-plugin
export default {"Item":"bB3eIpSE57HIS9Z0XzOp","Account":"CHUlmpuHzoWmOj7ElYV8"};